/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import assetUnitWidgetTemplate from './asset-unit-widget.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.assetUnitWidget', [])
    .directive('agAssetUnitWidget', AssetUnitWidget)
    .name;

/*@ngInject*/
function AssetUnitWidget() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: AssetUnitWidgetController,
        controllerAs: 'vm',
        templateUrl: assetUnitWidgetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function AssetUnitWidgetController($scope, $translate, types, agTypes, userService) {

    let vm = this;

    vm.types = types;
    vm.agTypes = agTypes;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';

    var defaultTitle = $translate.instant('ag.asset.asset-unit') + '';


    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.ctx.widgetTitle = defaultTitle;
        }
    });

    $scope.$watch(function() { return vm.entityName ? vm.entityName : defaultTitle; }, function(title) {
        if (vm.showData && vm.ctx) {
            vm.ctx.widgetTitle = title;
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$on('assetUnitSelected', function(event, entityId, entitySubtype, entityName, assetId, assetType) {
        if (vm.showData) {
            if (!angular.equals(vm.entityId, entityId)) {
                vm.entityId = entityId;
                vm.entitySubtype = entitySubtype;
                vm.entityName = entityName;
                vm.assetId = assetId;
                vm.assetType = assetType;
            }
        }
    });



}

